module.exports = __webpack_public_path__ + "img/logotipo_chame_cinza.78e7935d.png";